import * as Yup from "yup";

// Login Validation
export const loginValidation = Yup.object().shape({
  email: Yup.string().email("Invalid email Id").required("Email is required"),
});

export const loginOtpValidation = Yup.object().shape({
  otp: Yup.string().required("OTP is required"),
});

// Register Validation
export const registerValidation = Yup.object().shape({
  email: Yup.string().email("Invalid email Id").required("Email is required"),
  phone: Yup.string("").required("Please enter phone."),
});

export const registerValidation2 = Yup.object().shape({
  email: Yup.string().email("Invalid email Id").required("Email is required"),
  phone: Yup.string("").required("Please enter phone."),
  utmCode: Yup.string("").required("Please enter UTM code."),
  referralCode: Yup.string("").required("Please enter referral code."),
});
